<template>
  <div class="flex-header-section">
    <select-all-search-header class="select-all flex-header main-checkbox" />
    <div class="flex-header">
      <span>Asset</span>
    </div>
    <div class="flex-header">
      <span>Status</span>
    </div>
    <div class="flex-header">
      <span>Email</span>
    </div>
    <div class="flex-header">
      <span>Message</span>
    </div>
    <div class="flex-header">
      <span>Product</span>
    </div>
    <div class="flex-header">
      <span>Actions</span>
    </div>
  </div>
</template>

<script>
import SelectAllSearchHeader from '../../assets/shared/SelectAllSearchHeader'

export default {
  components: { SelectAllSearchHeader }
}
</script>
